<app-page-headline
        [breadcrumbTitle]="'Datenschutz'"
        [breadcrumbs]="[
            { label: 'Häufige Fragen (FAQ)', link: '/' },
            { label: 'FAQ', iconClass: 'fa fa-angle-double-right', link: '/faq' }]"
        [mainTitle]="'Ihre Fragen – Unsere Antworten'"
        [subtitle]="'Hier finden Sie Antworten auf die häufigsten Fragen rund um unsere Branchenlösungen, den Kaufprozess und unsere Dienstleistungen. Sie haben eine spezielle Frage, die hier nicht beantwortet wird? Kontaktieren Sie uns gerne direkt'"
        [titleImagePath]="'assets/images/saas1/title-logo.png'"
        [backgroundImage]="'assets/images/saas1/work-bg.png'">
</app-page-headline>
<app-enterprice-sass-faq datasetIdentifier="long"></app-enterprice-sass-faq>
